export default __webpack_public_path__ + "static/media/feather_minus-circle-enable.6bdd2ca6.svg";